import { path } from 'ramda';
import { HttpClient } from '@wix/http-client';
import { wixOrEditorxDomain } from '../../env/utils';

export const getInstance = (metaSiteId: string) => async (): Promise<string> => {
  const { BusinessManagerAPI } = window;
  if (BusinessManagerAPI) {
    return BusinessManagerAPI.getCurrentInstance(BusinessManagerAPI.appDefIds.metaSite);
  }

  const httpClient = new HttpClient();

  const origin = process.env.NODE_ENV === 'development' ? '' : `https://${wixOrEditorxDomain}`;
  return httpClient
    .get(`${origin}/_api/video-maker-modal/getInstance?metaSiteId=${metaSiteId}&origin=media-manager`, {
      withCredentials: true,
    })
    .then(path(['data', 'instance'])) as any as string;
};
